import { baseUrl } from './env';
import Vue from 'vue'


	export default async(url = '', data = {}, type = 'GET', method = 'fetch') => {
    type = type.toUpperCase();
    url = baseUrl + url;
    if (type == 'GET') {
      let dataStr = ''; //数据拼接字符串
      Object.keys(data).forEach(key => {
        dataStr += key + '=' + data[key] + '&';
      })
  
      if (dataStr !== '') {
        dataStr = dataStr.substr(0, dataStr.lastIndexOf('&'));
        url = url + '?' + dataStr;
      }
    }
  
    if (window.fetch && method == 'fetch') {
		let requestConfig = {
			method: type,
			headers: {
				'Access-Control-Allow-Origin':'*',
				'Accept': 'application/json',
				'Content-type':"application/x-www-form-urlencoded"
			},
			mode: "cors",
			cache: "no-store"
		}
    //   let requestConfig = {
    //     method: type,
    //     headers: {
    //       'Accept': 'application/json',
    //       'Content-Type': 'application/json',
    //       'Authorization': 'Bearer ' + localStorage.getItem('token'),
    //       'Language': localStorage.getItem("Language")
    //     },
    //     mode: "cors",
    //     cache: "no-store"
    //   }
      if (type == 'POST') {
        Object.defineProperty(requestConfig, 'body', {
          value: JSON.stringify(data)
        })
      }
      try {
        const response = await fetch(url, requestConfig);
				// 判断返回状态
		
						let _status = response.status;
						// 401判断token失效
						const responseJson = await response.json();
						var that = this
						if(responseJson.orsuccess =='-98'){
						
							// alert('token失效请重新登陆')
							setTimeout(function(){
							
								// that.$store.commit('login', 'false')
								sessionStorage.removeItem('userInfo')
								that.$router.push({ path: '/login' })
								// window.location.href = 'http://admin.xiangjidaren.com/#';
								
								},100);
						  }
						  // 无效的token
						  if(responseJson.orsuccess =='-99'){
							console.log('-99')
							// that.$router.push({ path: '/login' })
				
							// alert('token失效请重新登陆')
							setTimeout(function(){
								sessionStorage.removeItem('userInfo')
								// that.$store.commit('login', 'false')
								// window.location.href = 'http://admin.xiangjidaren.com/#';
								// window.location.href = 'http://admin.xiangjidaren.com/#';
								
								},100);
						  }
						  // 操作失败
						  if(responseJson=='-1'){
							alert('操作失败！')
						  }
						//   if(responseJson.orsuccess =='1'){
						// 	alert('操作失败！')

						// 	setTimeout(function(){

						// 		window.location.href = 'http://admin.xiangjidaren.com/#';
								
						// 		},100);
 						//   }
						  
							return responseJson		
					
      } catch (error) {
        throw new Error(error)
      }
    } else {
      return new Promise((resolve, reject) => {
        let requestObj;
        if (window.XMLHttpRequest) {
          requestObj = new XMLHttpRequest();
        } else {
          requestObj = new ActiveXObject;
        }
        let sendData = '';
        if (type == 'POST') {
          sendData = JSON.stringify(data);
        }
        if (type == 'POST2') {
          sendData = data;
        }
  
        requestObj.open(type, url, true);
        
        requestObj.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
		requestObj.setRequestHeader("Authorization", 'Bearer ' + localStorage.getItem('token'));
		
        requestObj.send(sendData);
  
        requestObj.onreadystatechange = () => {
          if (requestObj.readyState == 4) {
            if (requestObj.status == 200) {
              let obj = requestObj.response
              if (typeof obj !== 'object') {
                obj = JSON.parse(obj);
              }
              resolve(obj)
            } else {
              reject(requestObj)
            }
          }
        }
      })
    }
	}
	
	export function ajax(cfg) {
		if (!cfg.url) {
			return;
		}
		if (!cfg.type) {
			cfg.type = "get";
		}
		if (cfg.async != false && cfg.async != true) {
			cfg.async = true;
		}
		var xmlHttp;
		if (window.ActiveXObject) {
			xmlHttp = new ActiveXObject("Microsoft.XMLHTTP");
		}
		else if (window.XMLHttpRequest) {
			xmlHttp = new XMLHttpRequest();
		}
		else {
			return;
		}
		if (!cfg.dataType) {
			cfg.dataType = "";
		}
		else {
			cfg.dataType = cfg.dataType.toLowerCase();
		}
		xmlHttp.onreadystatechange = function () {
			if (xmlHttp.readyState == 4) {
				if (cfg.onAjaxReady) {
					cfg.onAjaxReady.call(xmlHttp);
				}
				if (xmlHttp.status == 200) {
					if (cfg.success) {
						var contentType = xmlHttp.getResponseHeader("Content-Type");
						if (contentType == null) {
							cfg.success(null);
						}
						else if (contentType.indexOf("application/json") > -1 || cfg.dataType == "json") {
							cfg.success(parseJson(xmlHttp.responseText));
						}
						else {
							cfg.success(xmlHttp.responseText);
						}
					}
				}
				else if (xmlHttp.status == 600) {
					window.top.location.href = xmlHttp.statusText;
				}
				else {
					if (cfg.error) {
						cfg.error(xmlHttp.responseText);
					}
				}
				if (cfg.complete) {
					if (cfg.complete) {
						cfg.complete();
					}
				}
			}
		}
		xmlHttp.open(cfg.type, cfg.url, cfg.async);
		if (!cfg.contentType) {
			cfg.contentType = "application/x-www-form-urlencoded;charset=UTF-8";
		}
		if (cfg.headers && cfg.headers.length > 0) {
			for (var i = 0; i < cfg.headers.length; i++) {
				xmlHttp.setRequestHeader(cfg.headers[i].name, cfg.headers[i].value);
			}
		}
		if (cfg.data) {
			if (typeof (cfg.data) == "object") {
				var temp = "", flag = 0;
				for (var i in cfg.data) {
					if (flag == 1) {
						temp += "&";
					}
					else {
						flag = 1;
					}
					temp += i + "=" + encodeURIComponent(cfg.data[i]);
				}
				cfg.data = temp;
			}
		}
		if (cfg.onAjaxSend) {
			cfg.onAjaxSend.call(xmlHttp);
		}
		xmlHttp.send(cfg.data);
	}
	
	function parseJson(data) {
		return (new Function("return " + data))();
	}




// WEBPACK FOOTER //
// ./src/config/fetch.js